// ---------------------------------------------------------------------------------------------------------
// --	環境関連
// ---------------------------------------------------------------------------------------------------------

export function isSP()
{
  return ($(window).innerWidth() <= 768);
}

export function isPC()
{
  return ($(window).innerWidth() >= 769);
}

export function deviceType()
{
  var ua = navigator.userAgent;
  if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)
  {
      return 'sp';
  }
  else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0)
  {
      return 'tablet';
  }
  else
  {
      return 'pc';
  }
}

export function isAndroid()
{
  var ua = navigator.userAgent;
  return (ua.indexOf('Android') > 0);
}


// ---------------------------------------------------------------------------------------------------------
// --	ターゲットの位置取得関連
// ---------------------------------------------------------------------------------------------------------

//指定された範囲内までスクロールが進んだかどうかの判定
export function isViewed(target, scrollY, per = 1.0, originY = 0.0)
{
  const targetTop = (target.offset().top - scrollY) + (target.height() * originY);
  const targetBottom = (target.offset().top - scrollY) + target.height();
  const winBottomY = $(window).innerHeight() * per;

  return (targetTop <= winBottomY && targetBottom >= 0);
}


// ---------------------------------------------------------------------------------------------------------
// --	角度の計算
// ---------------------------------------------------------------------------------------------------------

//角度をラジアンに変換
export function rotToRadian(rot)
{
  return rot * (Math.PI / 180);
}

//ラジアンを角度に変換
export function radianToRot(radian)
{
  return radian / (Math.PI / 180);
}


// ---------------------------------------------------------------------------------------------------------
// --	スクロールの制御
// ---------------------------------------------------------------------------------------------------------

//スクロール禁止用関数
export function stopScroll()
{
  console.log("stopScroll");

  //PC用
  // const scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
  // document.getElementsByTagName('html')[0].addEventListener(scroll_event, moveFunc, { passive: false });

  //SP用
  document.getElementsByTagName('html')[0].addEventListener( 'touchmove' , moveFunc, { passive: false } );
}


//スクロール復活用関数
export function startScroll()
{
  console.log("startScroll");

  //PC用
  // const scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
  // document.getElementsByTagName('html')[0].removeEventListener(scroll_event, moveFunc, { passive: false });

  // スクロール停止することを停止する処理
  document.getElementsByTagName('html')[0].removeEventListener( 'touchmove', moveFunc, { passive: false } );
}

function moveFunc(e)
{
  e.preventDefault();
}

// ---------------------------------------------------------------------------------------------------------
// --	スムーススクロール
// ---------------------------------------------------------------------------------------------------------

export function scrollTo(tag, duration = 0.6)
{
  // console.log("scrollTo:" + tag);

  let opTop = 0;

  if(tag != "home" && $("#"+tag).length)
  {
    const target = $("#"+tag);
    opTop = target.offset().top - $("header").outerHeight();
  }

  TweenMax.to($('html, body'), duration, {"scrollTop":opTop, ease:Power2.easeInOut});
}


// ---------------------------------------------------------------------------------------------------------
